import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import { useLocation } from 'react-router-dom';
import { isWebviewMode } from 'Utils/webviewMode';

const LeagueCenter = loadable(() => pMinDelay(import('./LeagueCenter'), 300), {
  fallback: <Loading />
});

const AsyncLeagueCenter = props => {
  const location = useLocation();
  const isWebview = isWebviewMode(location.search);

  const pageConfig = {
    headerType: isWebview && (props.userAgent.device?.type === 'mobile') ? 'mobile-none' : 'full',
    footerType: isWebview && (props.userAgent.device?.type === 'mobile') ? 'none' : 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <LeagueCenter { ...props }/>
    </ApplicationLayout>
  );
};

AsyncLeagueCenter.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncLeagueCenter;

